var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRotateHoraire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.111 16.08H.444V1.413h.89v13.778H15.11z",
    fill: "#13123A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.649 1.965c5.378.524 9.804 4.267 11.342 9.28",
    stroke: "#13123A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.044 11.129 2.454 2.684 1.102-3.458z",
    fill: "#13123A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .524h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotateHoraire);
export default __webpack_public_path__ + "static/media/ic_rotate_horaire.b3e83154d8c2e73b1309f8f6928053d1.svg";
export { ForwardRef as ReactComponent };